import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProMarketingLink from './ProMarketingLink';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import './PromoBar.css';

interface PromoBarProps {
  message: string;
  ctaLabel?: string;
  ctaHref?: string;
  onCtaClick?: () => void;
  /** Notifie le parent quand la barre est fermée (ex. recalcul offset menu mobile). */
  onDismiss?: () => void;
}

export default function PromoBar({ message, ctaLabel, ctaHref, onCtaClick, onDismiss }: PromoBarProps) {
  const { t } = useTranslation('marketing');
  const [visible, setVisible] = useState(true);
  const isInternalLink = ctaHref?.startsWith('/');

  if (!visible) return null;

  const ctaContent = ctaLabel ? (
    isInternalLink ? (
      <ProMarketingLink className="promo-bar__cta promo-bar-cta" to={ctaHref || '/'} onClick={onCtaClick}>
        {ctaLabel} →
      </ProMarketingLink>
    ) : (
      <a
        className="promo-bar__cta promo-bar-cta"
        href={ctaHref}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onCtaClick}
      >
        {ctaLabel} →
      </a>
    )
  ) : null;

  return (
    <AnimatePresence>
      <motion.div
        className="promo-bar"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="promo-bar__inner">
          <p className="promo-bar__message">{message}</p>
          <button
            type="button"
            className="promo-bar__close"
            onClick={() => {
              setVisible(false);
              onDismiss?.();
            }}
            aria-label={t('promoBar.closeAriaLabel')}
          >
            <X size={18} />
          </button>
          <div className="promo-bar__actions">
            <span className="promo-bar__emoji" aria-hidden="true">
              🚀
            </span>
            {ctaContent}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
